import { useEffect } from "react";
import { Helmet } from "react-helmet";

import '../pages/Green.css'
import GreenBan from '../components/GreenBan'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import GREENAUDITIMAGE from '../images/GREENAUDITIMAGE.png'

import {
  FaLeaf,
  FaUniversity,
  FaIndustry,
  FaHospital,
  FaBuilding,
  FaRecycle,
  FaSeedling
} from "react-icons/fa";

import {



  FaBolt,
  FaTint,
  FaTree,
  FaClipboardList,



  FaChartBar
} from "react-icons/fa";



// import {




//   FaLeaf
// } from "react-icons/fa";

export default function Grreen() {


  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <>
      <Helmet>
        <title>Green Audit Services in Madurai | Environmental Audit & Certification</title>
        <meta name="description" content="RAD EnviroNex offers comprehensive Green Audit services in Madurai. We evaluate environmental performance, biodiversity, and sustainability for NAAC compliance." />
        <meta name="keywords" content="Green Audit Madurai, Environmental Audit Tamil Nadu, NAAC Green Audit, sustainable campus Madurai, biodiversity audit, campus sustainability audit" />
        <link rel="canonical" href="https://radenvironex.com/Green" />
      </Helmet>
      <Navbar />

      <GreenBan />







      {/* GREEN AUDIT SECTION */}
      <section id="green-audit-section">
        <div className="green-audit-wrapper" data-aos="slide-up">

          <h2>Green Audit</h2>

          <p className="green-audit-intro">
            At <strong>RAD EnviroNex,</strong> we conduct comprehensive Green Audits to help institutions and organizations evaluate their environmental performance and sustainability practices. Our Green Audit assesses key areas such as energy usage, water management, waste handling, and biodiversity conservation within the campus or facility.
          </p>
          <p className="green-audit-intro">
            Through this process, we identify opportunities to improve resource efficiency, reduce environmental impact, and promote eco-friendly practices. Our goal is to support organizations in building greener, more sustainable environments while aligning with environmental standards and responsible resource management.
          </p>

          <div className="green-audit-grid">

            <div data-aos="slide-up">
              <FaUniversity />
              <span>Educational Institutions</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="100">
              <FaIndustry />
              <span>Industries & Factories</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="200">
              <FaHospital />
              <span>Hospitals & Healthcare Facilities</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="300">
              <FaBuilding />
              <span>Commercial Establishments</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="400">
              <FaRecycle />
              <span>Resource Conservation Assessment</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="500">
              <FaSeedling />
              <span>Sustainable & Eco-Friendly Practices</span>
            </div>

          </div>

        </div>
      </section>


      {/* GREEN AUDIT – NAAC RELEVANCE */}
      {/* <section id="green-audit-naac-section">
        <div className="green-naac-wrapper" data-aos="slide-up"> */}

      {/* <h2>NAAC Relevance</h2>

    <p className="green-naac-intro">
      The <strong>Green Audit</strong> conducted by <strong>RAD EnviroNex</strong>
      supports <strong>NAAC Criterion 7 – Institutional Values and Best Practices</strong>,
      with a strong focus on sustainability and environmental quality.
    </p> */}

      {/* NAAC POINTS */}
      {/* <div className="green-naac-points"> */}

      {/* <div data-aos="slide-up">
        <FaLeaf />
        <span>Environmental Consciousness</span>
      </div>

      <div data-aos="slide-up" data-aos-delay="100">
        <FaTree />
        <span>Sustainable Campus Initiatives</span>
      </div> */}

      {/* <div data-aos="slide-up" data-aos-delay="200">
        <FaClipboardList />
        <span>Regular Quality Audits on Environment</span>
      </div> */}

      {/* </div> */}
      {/* 
          <h3 className="green-naac-subtitle">Applicable For</h3> */}

      {/* APPLICABLE */}
      {/* <div className="green-naac-applicable">

            <div data-aos="slide-up">
              <FaUniversity />
              <span>Colleges & Universities</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="100">
              <FaUniversity />
              <span>Schools & Educational Campuses</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="200">
              <FaHospital />
              <span>Hospitals & Healthcare Facilities</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="300">
              <FaIndustry />
              <span>Industries & Manufacturing Units</span>
            </div>

            <div data-aos="slide-up" data-aos-delay="400">
              <FaBuilding />
              <span>Commercial Buildings & Offices</span>
            </div>

          </div> */}

      {/* <h3 className="green-naac-subtitle">
      What RAD EnviroNex Green Audit Certificate Covers
    </h3> */}

      {/* CERTIFICATE COVERS */}
      {/* <div className="green-naac-covers"> */}

      {/* <div data-aos="slide-up">
        <FaBolt />
        <span>Energy Usage & Conservation</span>
      </div> */}

      {/* <div data-aos="slide-up" data-aos-delay="100">
        <FaTint />
        <span>Water Management & Conservation</span>
      </div> */}

      {/* <div data-aos="slide-up" data-aos-delay="200">
        <FaRecycle />
        <span>Solid, Liquid & E-Waste Management</span>
      </div> */}

      {/* <div data-aos="slide-up" data-aos-delay="300">
        <FaTree />
        <span>Green Campus & Biodiversity Initiatives</span>
      </div> */}

      {/* <div data-aos="slide-up" data-aos-delay="400">
        <FaLeaf />
        <span>Environmental Policy & Compliance</span>
      </div> */}

      {/* <div data-aos="slide-up" data-aos-delay="500">
        <FaChartBar />
        <span>NAAC-Aligned Documentation & Certification</span>
      </div> */}

      {/* <div data-aos="slide-up" data-aos-delay="600">
        <FaClipboardList />
        <span>Sustainability Recommendations & Action Plan</span>
      </div> */}

      {/* </div> */}

      {/* </div> */}
      {/* </section> */}

      {/* NAAC SUPPORT SECTION */}
      {/* <section id="naac-support-section">
  <div className="naac-support-wrapper" data-aos="slide-up">

    <h2>NAAC Support</h2>

    <p className="naac-support-intro">
      RAD EnviroNex audit services support
      <strong> NAAC Criterion 7.1.6</strong> and contribute towards
      institutional sustainability and environmental best practices.
    </p>

    <div className="naac-support-grid">

      <div data-aos="slide-up">
        <FaBolt />
        <span>Energy Conservation</span>
      </div>

      <div data-aos="slide-up" data-aos-delay="100">
        <FaRecycle />
        <span>Waste Management</span>
      </div>

      <div data-aos="slide-up" data-aos-delay="200">
        <FaTint />
        <span>Water Conservation</span>
      </div>

      <div data-aos="slide-up" data-aos-delay="300">
        <FaLeaf />
        <span>Green Campus Initiatives</span>
      </div>

    </div>

  </div>
</section> */}







      {/* ENERGY AUDIT IMAGE SHOWCASE
      <section id="energy-audit-image-section">
        <div
          className="energy-audit-image-wrapper"
          data-aos="slide-up"
        >
          <center>
            <h2>Green Audit Assessment & Certification</h2>
          </center>
          <div className="energy-audit-image-box">
            <img
              src={GREENAUDITIMAGE}
              alt="RAD EnviroNex Energy Audit Assessment"
            />
          </div>
        </div>
      </section> */}





      <Footer />
    </>
  )
}
